function toDateTime (dateStr, timeStr) {
    let [day, month, year] = dateStr.split('/').map(Number);

    // טיפול בשעה
    let times = timeStr.split(/[-\s]/).map(time => time.split(':').map(Number));
    let [startHour, startMinute] = times[0];
    let dateTime = new Date(year, month - 1, day, startHour, startMinute);

    if (times.length > 1) {
        let [endHour, endMinute] = times[1];
        let start = new Date(year, month - 1, day, startHour, startMinute);
        let end = new Date(year, month - 1, day, endHour, endMinute);

        // חישוב ממוצע זמן
        let averageTime = new Date((start.getTime() + end.getTime()) / 2);
        dateTime = averageTime;
    }

    return dateTime;
}



export function sortCarData (data) {
    let dataReturn = [...data];

    dataReturn.sort((a, b) => {
        let dataA = toDateTime(a[3], a[5]);
        let dataB = toDateTime(b[3], b[5]);

        return dataA - dataB;
    });

    return dataReturn;
}



export default function sortData (data) {
    let dataReturn = {}

    let [num1, num2] = [4, 8];

    Object.keys(data).forEach(key => {

        if (key === 'S') {
            num1 = 2;
            num2 = 6;
        }
            // המרת הנתונים לרשימה של אובייקטים עם מפתחות
        let dataList = Object.entries(data[key]).map(([subkey, entry]) => ({
            key: subkey,
            ...entry
        }));

        // מיון הרשימה לפי תאריך ושעה
        dataList.sort((a, b) => {
            let dateA = toDateTime(a.flight[num1], a.flight[num2]);
            let dateB = toDateTime(b.flight[num1], b.flight[num2]);
            return dateA - dateB;
        });

        // המרת הרשימה חזרה לאובייקט
        dataReturn[key] = [];

        dataList.forEach(item => {
            dataReturn[key].push ({
                ...item
            })
        });
    })

    return dataReturn;
}